// calculation-selectors.ts
import { createSelector, select } from '@ngrx/store';
import { CalculationState, createEmptyAggregation } from './calculation-state';
import { AppState } from './app-state';

export const selectAppState = (state: AppState) => state;

// Create selectors
export const selectCalculationState = (state: AppState) => state.calculation;

// Base selector to access the entire UndoRedoState
// const selectUndoRedoCalculationState = (state: AppState) => state.calculation;

// Selector to access the present state within UndoRedoState
// export const selectCalculationState = createSelector(
//   selectUndoRedoCalculationState,
//   (undoRedoState: UndoRedoState<CalculationState>) => undoRedoState.present
// );

// export const selectCalculationState = createSelector(
//   selectUndoRedoCalculationState,
//   (undoRedoState: UndoRedoState<CalculationState>) => undoRedoState.present
// );

export const selectCalculationFeature = createSelector(
  selectCalculationState,
  (state: CalculationState) => state
);

export const selectLines = createSelector(
  selectCalculationState,
  (state: CalculationState) => state.lines
);

export const selectTemplate = createSelector(
  selectCalculationState,
  (state: CalculationState) => state.template
);

export const selectHourRates = createSelector(
  selectCalculationState,
  (state: CalculationState) => state.hourRates
);

export const selectLoadingStatus = createSelector(
  selectCalculationState,
  (state: CalculationState) => state.loading
);

export const selectCalculationMeta = createSelector(
  selectCalculationState,
  (state: CalculationState) => state.meta
);

export const selectMaxVersion = createSelector(
  selectCalculationState,
  (state: CalculationState) => state.maxVersion
);

export const selectCurrentSelection = createSelector(
  selectCalculationState,
  (state: CalculationState) => state.currentSelection
);

export const selectIsLatestVersion = createSelector(
  selectCalculationState,
  (state: CalculationState) => (state.maxVersion !== undefined) && (state.meta?.currentVersion !== undefined) ? state.maxVersion === state.meta.currentVersion : false
);

export const selectAggregation = createSelector (
  selectCalculationState,
  (state: CalculationState) => state.aggregation
)

export const selectAggregationOnLoad = createSelector (
  selectCalculationState,
  (state: CalculationState) => state.aggregationOnLoad ?? createEmptyAggregation()
)

export const selectWarnings = createSelector (
  selectCalculationState,
  (state: CalculationState) => state.warnings ?? []
)

export const selectTemplateDictionary = createSelector (
  selectCalculationState,
  (state: CalculationState) => state.templateDict ?? {}
)

export const selectTail = createSelector (
  selectCalculationState,
  (state: CalculationState) => state.tail ?? []
)

export const selectViewlines = createSelector(
  selectCalculationState,
  (state: CalculationState) => state.viewModelLines ?? []
)

export const selectColumnDefinitions = createSelector(
  selectCalculationState,
  (state: CalculationState) => state.columns
)

export const partsShown = createSelector(
  selectCalculationState,
  (state: CalculationState) => state.show
)

export const selectTableLayout = createSelector(
  selectCalculationState,
  (state: CalculationState) => state.tableLayout
)

export const selectSideMenuOpen = createSelector(
  selectCalculationState,
  (state: CalculationState) => state.sideMenuOpen
)

export const selectCreatingIds = createSelector(
  selectCalculationState,
  state => state.creatingIds
);

export const selectStaleIds = createSelector(
  selectCalculationState,
  state => state.staleIds
);

export const isLineCreating = (id: string) => createSelector(
  selectCreatingIds,
  creating => !!creating[id]
);

export const isLineStale = (id: string) => createSelector(
  selectStaleIds,
  stale => !!stale[id]
);

